import React from 'react'

function ChevronDownIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.4873 8.89062L12.0119 16.366L4.53648 8.89062" stroke="#08081B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default ChevronDownIcon